export default __webpack_public_path__ + "static/media/T500_C_BD.f97e671c.pdf";